<template>
  <v-card class="mx-auto mt-15 pl-4 pr-4 pt-10 pb-10"
          outlined
          max-width="1000">
    <h2 class="text-center mb-4">{{$t('USER_GUIDE.CONTACT_TITLE')}}</h2>
    <span>{{$t('USER_GUIDE.CONTACT_CONTENT')}}</span>
    <div style="padding-left: 132px;" class="mt-10">
      <div class="d-flex  mb-4">
          <span class="font-weight-bold  text-left mr-6" style="    min-width: 100px;">
             {{$t('USER_GUIDE.CONTACT_EMAIL')}}
          </span>
        <template v-if="contactAdmin && contactAdmin.email && contactAdmin.email.length">
          <div v-for="email of contactAdmin.email" :key="email">
            {{ email || '' }}
          </div>
        </template>
      </div>
    </div>
    <div style="padding-left: 132px;" class="mt-10">
      <div class="d-flex  mb-4">
          <span class="font-weight-bold  text-left mr-6" style="    min-width: 100px;">
            {{$t('USER_GUIDE.CONTACT_PHONE')}}
          </span>
        <template v-if="contactAdmin && contactAdmin.phone_number && contactAdmin.phone_number.length">
          <div v-for="phoneNumber of contactAdmin.phone_number" :key="phoneNumber">
            {{ phoneNumber || '' }}
          </div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import Vue from "vue"
import msDataProvider from "@/services/msDataProvider";

export default Vue.extend({
  name: "Index",
  data() {
    return {
      contactAdmin: {}
    }
  },
  watch: {},
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      const resClientSetting = await msDataProvider.getData("clientSetting")
      if (resClientSetting) {
        if (resClientSetting && resClientSetting.settings && resClientSetting.settings.contact_admin) {
          this.contactAdmin = resClientSetting.settings.contact_admin
        } else if (resClientSetting && resClientSetting.settings && resClientSetting.settings.contact_admins) {
          this.contactAdmin = {
            displayName: resClientSetting.settings.contact_admins.map(admin => admin.display_name),
            email: resClientSetting.settings.contact_admins.map(admin => admin.email),
            phone_number: resClientSetting.settings.contact_admins.map(admin => admin.phone_number),
          }
        }
      }
    }
  },

})
</script>

<style lang="scss">
.text-warning {
  //color: #ffcc00!important;
  font-weight: bold !important;
}
</style>
